// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__jGxVD","boxliNav":"Navbar_boxliNav__dRyrn"};